<template>
  <div class="relative isolate bg-stone-950 pb-32 pt-24 sm:pt-32">
    <div
      class="absolute inset-x-0 top-1/2 -z-10 -translate-y-1/2 transform-gpu overflow-hidden opacity-30 blur-3xl"
      aria-hidden="true"
    >
      <div
        class="ml-[max(50%,38rem)] aspect-[1313/771] w-[82.0625rem] bg-gradient-to-tr from-primary-600 to-secondary-400"
        style="
          clip-path: polygon(
            74.1% 44.1%,
            100% 61.6%,
            97.5% 26.9%,
            85.5% 0.1%,
            80.7% 2%,
            72.5% 32.5%,
            60.2% 62.4%,
            52.4% 68.1%,
            47.5% 58.3%,
            45.2% 34.5%,
            27.5% 76.7%,
            0.1% 64.9%,
            17.9% 100%,
            27.6% 76.8%,
            76.1% 97.7%,
            74.1% 44.1%
          );
        "
      />
    </div>
    <div
      class="absolute inset-x-0 top-0 -z-10 flex transform-gpu overflow-hidden pt-32 opacity-25 blur-3xl sm:pt-40 xl:justify-end"
      aria-hidden="true"
    >
      <div
        class="ml-[-22rem] aspect-[1313/771] w-[82.0625rem] flex-none origin-top-right rotate-[30deg] bg-gradient-to-tr from-primary-600 to-secondary-400 xl:ml-0 xl:mr-[calc(50%-12rem)]"
        style="
          clip-path: polygon(
            74.1% 44.1%,
            100% 61.6%,
            97.5% 26.9%,
            85.5% 0.1%,
            80.7% 2%,
            72.5% 32.5%,
            60.2% 62.4%,
            52.4% 68.1%,
            47.5% 58.3%,
            45.2% 34.5%,
            27.5% 76.7%,
            0.1% 64.9%,
            17.9% 100%,
            27.6% 76.8%,
            76.1% 97.7%,
            74.1% 44.1%
          );
        "
      />
    </div>
    <div class="mx-auto max-w-7xl px-6 lg:px-8">
      <div class="mx-auto max-w-xl text-center">
        <h2
          class="text-lg font-semibold leading-8 tracking-tight text-primary-600"
        >
          {{ content.preHeadline }}
        </h2>
        <p
          class="mt-2 text-3xl font-bold tracking-tight text-white sm:text-4xl"
        >
          {{ content.headline }}
        </p>
      </div>

      <div class="mx-auto mt-16 max-w text-sm leading-6 text-white sm:mt-20">
        <Carousel :breakpoints="breakpoints" :wrap-around="true">
          <Slide
            v-for="testimonial in content.testimonials"
            :key="testimonial?.id"
          >
            <figure
              data-aos="zoom-in"
              class="rounded-2xl bg-white/5 p-6 shadow-lg ring-1 ring-gray-900/5 carousel__item m-5"
            >
              <blockquote class="text-gray-100">
                <RichText
                  v-if="testimonial?.text"
                  :text="testimonial?.text"
                ></RichText>
              </blockquote>
              <figcaption class="mt-6 flex items-center gap-x-4">
                <Image
                  v-if="testimonial?.image?.data?.attributes"
                  :image="testimonial.image.data.attributes"
                  size="xs"
                  :img-attrs="{
                    class: 'h-x w-10 rounded-full',
                  }"
                />
                <div class="text-left">
                  <div class="font-semibold">{{ testimonial?.name }}</div>
                  <div class="text-gray-400">
                    {{ testimonial?.company }}
                  </div>
                </div>
              </figcaption>
            </figure>
          </Slide>

          <template #addons>
            <Navigation />
          </template>
        </Carousel>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ComponentSectionsTestimonials } from '~/types/gql/graphql'
import 'vue3-carousel/dist/carousel.css'

const props = defineProps({
  content: {
    type: Object as PropType<ComponentSectionsTestimonials>,
    required: true,
  },
})
const breakpoints = {
  600: {
    itemsToShow: 1.5,
    snapAlign: 'center',
  },
  1024: {
    itemsToShow: 2.5,
    snapAlign: 'center',
  },
}
</script>
